module.exports = __webpack_public_path__ + "img/notify.c1b95599.svg";